import FlightCancelation from './FlightCancelation';
export default FlightCancelation;
